var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGifts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 35,
    viewBox: "0 0 29 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.64926 6.8104C11.1448 8.68517 12.1333 10.5833 12.1333 10.5833C12.1333 10.5833 8.98203 10.6344 7.62353 9.59983C6.26504 8.56483 5.67701 6.33164 5.67701 6.33164C5.67701 6.33164 7.28691 5.78709 8.64926 6.8104Z",
    fill: "#E96666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.322 10.057C10.4792 9.428 7.62941 8.92326 6.78313 7.97137C5.93686 7.01992 5.69188 6.31909 5.69188 6.31909C5.69188 6.31909 5.31714 7.81121 4.75352 8.6657C4.19034 9.5202 4.16978 10.9218 5.94499 11.5365C7.72063 12.1512 8.91853 11.5854 9.72283 12.0646C10.5271 12.5434 11.322 10.057 11.322 10.057Z",
    fill: "#E96666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.322 10.057C10.4792 9.428 7.62941 8.92326 6.78313 7.97137C5.93686 7.01992 5.69188 6.31909 5.69188 6.31909C5.69188 6.31909 5.31714 7.81121 4.75352 8.6657C4.19034 9.5202 4.16978 10.9218 5.94499 11.5365C7.72063 12.1512 8.91853 11.5854 9.72283 12.0646C10.5271 12.5434 11.322 10.057 11.322 10.057Z",
    fill: "#E96666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6658 6.66876C18.8409 8.7037 18.2473 10.4893 18.2473 10.4893C18.2473 10.4893 21.2363 10.2218 22.2256 9.10065C23.2149 7.97907 23.1198 5.78354 23.1198 5.78354C23.1198 5.78354 21.6624 5.55758 20.6658 6.66876Z",
    fill: "#E96666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6658 6.66876C18.8409 8.7037 18.2473 10.4893 18.2473 10.4893C18.2473 10.4893 21.2363 10.2218 22.2256 9.10065C23.2149 7.97907 23.1198 5.78354 23.1198 5.78354C23.1198 5.78354 21.6624 5.55758 20.6658 6.66876Z",
    fill: "#E96666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4455 10.2743C19.3046 8.47438 21.4272 7.99605 22.2829 7.19697C23.0358 6.49398 23.1197 5.7832 23.1197 5.7832C23.1197 5.7832 23.5112 6.8511 24.1476 7.41254C24.8705 8.05016 24.3506 9.39077 23.7082 10.1405C22.5381 11.5062 21.189 10.7535 20.601 11.3249C20.013 11.8962 18.4455 10.2743 18.4455 10.2743Z",
    fill: "#E96666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9454 3.50022C14.6067 8.12287 14.7168 11.2742 14.7168 11.2742C14.7168 11.2742 10.8216 8.20079 9.92779 5.66805C9.03397 3.13574 10.0023 0 10.0023 0C10.0023 0 12.0383 0.976563 12.9454 3.50022Z",
    fill: "#E96666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5448 4.73131C13.6934 9.74399 14.4121 12.7525 14.4121 12.7525C14.4121 12.7525 17.697 8.56484 18.1475 5.82388C18.5976 3.08292 17.1616 0.314697 17.1616 0.314697C17.1616 0.314697 15.0095 1.99468 14.5448 4.73131Z",
    fill: "#E96666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5448 4.73131C13.6934 9.74399 14.4121 12.7525 14.4121 12.7525C14.4121 12.7525 17.697 8.56484 18.1475 5.82388C18.5976 3.08292 17.1616 0.314697 17.1616 0.314697C17.1616 0.314697 15.0095 1.99468 14.5448 4.73131Z",
    fill: "#E96666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.764 11.1976C15.0552 9.50856 17.5225 5.23349 17.5225 3.25396C17.5225 1.27443 17.1341 0.324707 17.1341 0.324707C17.1341 0.324707 18.8823 1.14284 20.2421 1.14284C21.6019 1.14284 22.9034 2.35662 21.6409 5.28631C20.3783 8.21556 18.6301 9.32415 18.2416 10.8284C17.8527 12.3322 14.764 11.1976 14.764 11.1976Z",
    fill: "#E96666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5337 10.7816C14.0741 7.37054 11.4184 4.76464 10.5803 2.82493C9.84233 1.11855 10.0025 0 10.0025 0C10.0025 0 9.06971 1.21551 8.00416 1.46787C6.79298 1.75487 6.97457 4.18805 7.54675 5.86457C8.58876 8.91763 10.6813 9.02368 11.2488 10.3894C11.8163 11.7547 14.5337 10.7816 14.5337 10.7816Z",
    fill: "#E96666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5337 10.7816C14.0741 7.37054 11.4184 4.76464 10.5803 2.82493C9.84233 1.11855 10.0025 0 10.0025 0C10.0025 0 9.06971 1.21551 8.00416 1.46787C6.79298 1.75487 6.97457 4.18805 7.54675 5.86457C8.58876 8.91763 10.6813 9.02368 11.2488 10.3894C11.8163 11.7547 14.5337 10.7816 14.5337 10.7816Z",
    fill: "#E96666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8599 35.0001L28.5747 34.2317V11.2963L11.8599 9.85571V35.0001Z",
    fill: "#E9C092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.3379 34.136L11.8599 35.0001V9.85571L0.3379 11.2963V34.136Z",
    fill: "#E9C092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8599 10.528L28.5752 11.5175V15.8817L11.8599 16.9553L0.337971 16.2873V11.5175L11.8599 10.528Z",
    fill: "#E3A20A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7978 15.9952L28.9131 15.8281V10.8453L11.7978 9.85571V15.9952Z",
    fill: "#E9C092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000160217 15.8073L11.7976 15.9952V9.85571L-0.000160217 10.8453V15.8073Z",
    fill: "#E9C092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.3379 34.136L11.8599 35V16.9553L0.3379 16.2874V34.136Z",
    fill: "#EAD6C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000160217 15.8073L11.7976 15.9952V9.85571L-0.000160217 10.8453V15.8073Z",
    fill: "#EAD6C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.043 34.6697L23.4255 34.4684V10.5279L19.043 10.2747V34.6697Z",
    fill: "#E96666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.043 16.4094L23.4255 16.2475V15.8817L19.043 15.9328V16.4094Z",
    fill: "#D16119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9541 34.632L3.77114 34.3931L3.85808 10.5279L6.9541 10.2747V34.632Z",
    fill: "#E96666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9541 34.632L3.77114 34.3931L3.85808 10.5279L6.9541 10.2747V34.632Z",
    fill: "#F4A97F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9541 15.9181L3.83881 15.8683V16.6907L6.9541 16.7938V15.9181Z",
    fill: "#D16119"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.913,
    height: 35,
    fill: "white",
    transform: "matrix(-1 0 0 1 28.9131 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGifts);
export default __webpack_public_path__ + "static/media/gifts.08a04e3903515e293703bac716071ed5.svg";
export { ForwardRef as ReactComponent };